import { Icon } from "@iconify/react/dist/iconify.js";
import { NavLink, Link } from "react-router-dom";
import useSeccionesStore from "../store/seccionesStore";
import { useEffect } from 'react';

const Secciones = () => {
    const {secciones, iniciar} = useSeccionesStore();
    useEffect(() => {
        iniciar();
    }, [iniciar]);

    const obtenerSubsecciones = (seccion) => {
      if (Array.isArray(seccion.SUBSECCION)) return seccion.SUBSECCION;
      if (typeof seccion.SUBSECCION !== "string") return [];

      try {
        const subsecciones = JSON.parse(seccion.SUBSECCION);
        return Array.isArray(subsecciones) ? subsecciones : [];
      } catch (error) {
        console.error("Error al leer subsecciones:", error);
        return [];
      }
    };

    return (
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            {
              secciones.map((seccion) => {
                const subsecciones = obtenerSubsecciones(seccion);
                const esDropdown = subsecciones.length > 0;

                if (!esDropdown) {
                  if (seccion.ES_SIDEBAR_SEC !== 1) return null;

                  return (
                    <li key={seccion.ID_SEC}>
                      <NavLink to={`${seccion.RUTA_SEC}`} className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }>
                        <Icon icon={seccion.ICONO_SEC} className="menu-icon" />
                        <span>{seccion.NOMBRE_SEC}</span>
                      </NavLink>
                    </li>
                  );
                }

                return (
                  <li key={seccion.ID_SEC} className="dropdown">
                    <Link to={subsecciones[0].RUTA_SEC}>
                      <Icon icon={seccion.ICONO_SEC} className="menu-icon" />
                      <span>{seccion.NOMBRE_SEC}</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      {subsecciones.map((subseccion) => (
                        <li key={subseccion.ID_SEC}>
                          <NavLink to={`${subseccion.RUTA_SEC}`} className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }>
                            <i className="ri-circle-fill circle-icon text-primary-600 w-auto" /> {subseccion.NOMBRE_SEC}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              })
            }
          </ul>
        </div>
    );
}
 
export default Secciones;
